import { GraphQLError } from "graphql";
import React from "react";
import {
  BookingStatus,
  Cart,
  ChooseProposalFromKeysOccupantInput,
  CustomerBooking,
} from "rsl-api-106/lib/types";

type TCartContext = {
  cart: Cart | null;
  customerBooking: CustomerBooking | null;
  setCart: (cart: Cart | null) => void;
  setCustomerBooking: (booking: CustomerBooking | null) => void;
  loading: boolean;
  addProposalFromKeys: (
    proposalKeys: string[],
    occupantList: ChooseProposalFromKeysOccupantInput[] | undefined,
    callback: (err?: GraphQLError, response?: Cart) => void
  ) => void;
  removeStay: (
    stayGuiid: number,
    lastStayRemoveAllFerryConfirmed: boolean,
    callback: (err?: GraphQLError) => void
  ) => void;
  refresh: (callback: (err?: GraphQLError) => void) => void;
  addProductToGlobal: (
    productCode: string,
    productID: number,
    quantity: number,
    callback: (err?: GraphQLError) => void,
    stayGuiid?: number
  ) => void;
  addProductToOccupant: (
    productCode: string,
    productID: number,
    occupantGuiid: number,
    quantity: number,
    callback: (err?: GraphQLError) => void
  ) => void;
  addOccupant: (
    stayGuiid: number,
    callback: (err?: GraphQLError) => void
  ) => void;
  addBaby: (stayGuiid: number, callback: (err?: GraphQLError) => void) => void;
  updateOccupant: (
    occupantGuiid: number,
    firstName: string,
    lastName: string,
    birthDate: Date | null,
    callback: (err?: GraphQLError) => void
  ) => void;
  removeOccupant: (
    occupantGuiid: number,
    callback: (err?: GraphQLError) => void
  ) => void;
  addDiscountCode: (
    discountCode: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  addGiftCode: (
    giftCode: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  removeDiscountCode: (callback: (err?: GraphQLError) => void) => void;
  removeGiftCode: (
    giftCode: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  confirmFastCheckout: (
    confirmFastCheckout: boolean,
    callback: (err?: GraphQLError) => void
  ) => void;
  addObservation: (
    observation: string,
    reservationCartItemIDs: number[],
    callback: (err?: GraphQLError) => void
  ) => void;
  clear: (
    callback: (err?: GraphQLError) => void,
    updateState?: boolean
  ) => void;
  save: (
    passNewAmountLowerThanPrevious: boolean,
    fastCheckinCheckout: boolean,
    callback: (err?: GraphQLError) => void
  ) => void;
  switchToPartnerConvention: (
    partnerCode: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  deleteReservation: (
    reservationCartItemID: number,
    callback: (err?: GraphQLError) => void
  ) => void;
  updatePartnerPaymentsDue: (
    paymentdueType: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  updatePayerPaymentsDue: (
    paymentdueType: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  updateCartPaymentMethod: (
    bookingStatus: BookingStatus,
    ccardType: number,
    paymentMode: string,
    callback: (err?: GraphQLError) => void,
    paymentOptions?: string,
    automaticPayment?: boolean,
    manualPaymentOptions?: string,
    paymentModeSetOnlyFirst?: boolean,
    paymentAmount?: string,
    chequeNumber?: string,
    acceptUrl?: string,
    declineUrl?: string,
    cancelUrl?: string,
    exceptionUrl?: string
  ) => void;
  updateCartPaymentsDue: (
    paymentdueType: string,
    partnerPaymentdueType: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  addReservationToCart: (
    reservationID: number,
    fastCheckinCheckout: boolean,
    callback: (err?: GraphQLError) => void
  ) => void;
};

export const CartContext = React.createContext<TCartContext>({
  cart: null,
  customerBooking: null,
  loading: true,
  setCart: () => {},
  setCustomerBooking: () => {},
  addProposalFromKeys: () => {},
  removeStay: () => {},
  refresh: () => {},
  addProductToGlobal: () => {},
  addProductToOccupant: () => {},
  addOccupant: () => {},
  addBaby: () => {},
  updateOccupant: () => {},
  removeOccupant: () => {},
  addDiscountCode: () => {},
  addGiftCode: () => {},
  removeDiscountCode: () => {},
  removeGiftCode: () => {},
  confirmFastCheckout: () => {},
  addObservation: () => {},
  clear: () => {},
  save: () => {},
  switchToPartnerConvention: () => {},
  deleteReservation: () => {},
  updatePartnerPaymentsDue: () => {},
  updatePayerPaymentsDue: () => {},
  updateCartPaymentMethod: () => {},
  updateCartPaymentsDue: () => {},
  addReservationToCart: () => {},
});
